import axios from 'axios'
import store from '@/store'
import router from '@/router'
import CryptoJS from 'crypto-js'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Accept'       : 'application/json',
    'Content-Type' : 'application/json',
  },
})

//set Auth Headers in request
axiosInstance.interceptors.request.use( config => {

    const signature =
      CryptoJS.HmacSHA256(
        'static',
        process.env.VUE_APP_API_SIGNATURE
      ).toString()

    config.headers['X-Signature'] = signature

    if(store.getters.ACCESS_TOKEN !== undefined) {
      config.headers.Authorization = `Bearer ${store.getters.ACCESS_TOKEN}`
    }
    // 2. Add the Season UUID header
    const season = store.getters.SELECTED_SEASON
    if (season && season?.uuid) {
      config.headers['X-Season'] = season.uuid
    }
    return config
  },
  (error) => Promise.reject(error) 
)
// config.headers.Signature = SHA256(process.env.VUE_APP_API_SIGNATURE)


//send response as it is 
axiosInstance.interceptors.response.use(
response => response,
error => {
  console.log(error)
  // Reject promise if usual error
  if(error.response.status !== 401) {
    return Promise.reject(error)
  }


  //handle UnAuthorized Access
  if(error.response.status == 401) {
    if (router.currentRoute.name == 'Login') {
      return Promise.reject(error)
    }
    else{
      //PENDING : SEND back the Logout Request
      localStorage.clear()
      window.location.href= '/'
    }
  }
  
})

export default axiosInstance